import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import saveAs from 'file-saver';
import { first } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Location } from '@angular/common'

@Component({
  selector: 'app-pond-consolidated-detail-report',
  templateUrl: './pond-consolidated-detail-report.component.html',
  styleUrls: ['./pond-consolidated-detail-report.component.scss']
})
export class PondConsolidatedDetailReportComponent implements OnInit {
  @ViewChild('dataTable') tableContainer: ElementRef;
  miUnderProcessReport: MenuItem[];

  public pondConsolidatedTableData: any = [];
  public loading: boolean = false;
  public autoId: any = 0;
  public subscriptions: any = [];
  public subjectSub: any;

  constructor(
    private route: ActivatedRoute,
    private reportsService: ReportsService,
    private router: Router,
    private location: Location,
    private loader: AppLoaderService,
  ) { }

  ngOnInit(): void {
    this.miUnderProcessReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.pondConsolidatedTableData, `MI_Consolidated_Details`);
        },
      },
    ];

    this.loadData('', 0);
  }

  ngOnDestroy() {
    this.loader.close();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadData(finYear, autoId) {
    if (autoId == 0) {
      this.loading = true;
    }
    let sub = this.reportsService
      .getPondAppLevelWiseReport(finYear, autoId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          // console.log(data.length, data)
          if (data?.length > 0) {
            this.pondConsolidatedTableData = this.pondConsolidatedTableData.concat(data);

            const lastAutoId = data[data.length - 1].AutoId;
            this.loadData('', lastAutoId);
          } else {

          }
          // console.log(this.underProcessCount)
        },
        error: (err) => {
          // this.loading = false;
          this.loading = false;

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'AppId': d.AppId,
          'Farmer_Name': d.Farmer_Name,
          'Mobile': d.Mobile,
          'District': d.District,
          'Block': d.Block,
          'Village': d.Village,
          'Applicant_type': d.Applicant_type,
          'UserType': d.UserType,
          'Coverage_Area': d.Coverage_Area,
          'Total_Cost': d.Total_Cost,
          'IntimationStatus_Stage1': d.IntimationStatus_Stage1,
          'JeStatus_Stage1': d.JeStatus_Stage1,
          'XENStatus_Stage1': d.XENStatus_Stage1,
          'JE_EWStatus_Stage1': d.JE_EWStatus_Stage1,
          'DD_EWStatus_Stage1': d.DD_EWStatus_Stage1,
          'IntimationStatus_Stage2': d.IntimationStatus_Stage2,
          'JeStatus_Stage2': d.JeStatus_Stage2,
          'XENStatus_Stage2': d.XENStatus_Stage2,
          'JE_EWStatus_Stage2': d.JE_EWStatus_Stage2,
          'DD_EWStatus_Stage2': d.DD_EWStatus_Stage2,
          'LotStatus_Stage1': d.LotStatus_Stage1,
          'LotStatus_Stage2': d.LotStatus_Stage2,
          'LotStatus_Stage3': d.LotStatus_Stage3,
          'ReqFinYear': d.ReqFinYear,
          'KYCDate': d.KYCDate,
          'KYCStatus': d.KYCStatus,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onClickBack() {
    this.location.back();
  }

}

